<section class="schema-meta-form">
  @if (showTemplateEditor) {
  <div class="schema-meta-heading">
    <div>
      <span>{{'contentTypes.metaTemplateFields' | translate}}</span>
      <p>{{'contentTypes.metaTemplateFieldsDescription' | translate}}</p>
    </div>
    <button type="button" mat-button class="secondary-gray-button" (click)="addTemplateField()"><mat-icon>add</mat-icon> {{'contentTypes.addMetaField' | translate}}</button>
  </div>

  @if (!template.fields.length) {
    <div class="schema-meta-empty">
      <mat-icon>playlist_add</mat-icon>
      <div><strong>{{'contentTypes.noMetaFields' | translate}}</strong><p>{{'contentTypes.noMetaFieldsDescription' | translate}}</p></div>
    </div>
  }

  @for (field of template.fields; track $index; let index = $index) {
    <div class="meta-template-field">
      <div class="meta-template-field-header">
        <span>{{'contentTypes.metaField' | translate}} {{index + 1}}</span>
        <button type="button" mat-icon-button class="delete-action" (click)="removeTemplateField(index)" [attr.aria-label]="'contentTypes.deleteMetaField' | translate"><mat-icon>delete</mat-icon></button>
      </div>
      <div class="meta-template-field-inputs">
        <div class="meta-template-key-field">
          <mat-form-field appearance="outline">
            <mat-label>{{'contentTypes.key' | translate}}</mat-label>
            <input matInput required pattern="[a-zA-Z0-9_]+" [(ngModel)]="field.key" (ngModelChange)="updateTemplateField(index, field)">
            <mat-error>{{(!field.key?.trim() ? 'required' : 'contentTypes.metaTemplateKeyInvalid') | translate}}</mat-error>
          </mat-form-field>
          @if (isTemplateKeyDuplicate(index)) { <small class="meta-field-error">{{'contentTypes.metaTemplateKeyDuplicate' | translate}}</small> }
        </div>
        <mat-form-field appearance="outline"><mat-label>{{'contentTypes.metaFieldDisplayName' | translate}}</mat-label><input matInput required [(ngModel)]="field.displayName" (ngModelChange)="updateTemplateField(index, field)"><mat-error>{{'required' | translate}}</mat-error></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>{{'contentTypes.type' | translate}}</mat-label><mat-select [(ngModel)]="field.type" (ngModelChange)="updateTemplateField(index, field)">@for (type of types; track type.value) {<mat-option [value]="type.value">{{type.labelKey | translate}}</mat-option>}</mat-select></mat-form-field>
        <mat-form-field appearance="outline" class="meta-template-description"><mat-label>{{'contentTypes.description' | translate}}</mat-label><input matInput [(ngModel)]="field.description" (ngModelChange)="updateTemplateField(index, field)"></mat-form-field>
        <mat-checkbox [(ngModel)]="field.mandatory" (ngModelChange)="updateTemplateField(index, field)">{{'contentTypes.schemaRequiredField' | translate}}</mat-checkbox>
      </div>
    </div>
  }
  }

  @if (showFieldValues && template.fields.length) {
    <div class="field-meta-values">
      @if (showValuesHeading) {<span>{{'contentTypes.fieldMetadata' | translate}}</span>}
      @for (field of template.fields; track field.key) {
        @if (field.type === 'boolean' && field.mandatory) {
          <mat-form-field appearance="outline">
            <mat-label>{{field.displayName}}</mat-label>
            <mat-select [ngModel]="meta[field.key]" (ngModelChange)="updateMetaValue(field, $event)" required>
              <mat-option [value]="true">{{'contentTypes.metaYes' | translate}}</mat-option>
              <mat-option [value]="false">{{'contentTypes.metaNo' | translate}}</mat-option>
            </mat-select>
            @if (field.description) {<mat-hint>{{field.description}}</mat-hint>}
          </mat-form-field>
        } @else if (field.type === 'boolean') {
          <mat-slide-toggle [ngModel]="meta[field.key] === true" (ngModelChange)="updateMetaValue(field, $event)">{{field.displayName}}</mat-slide-toggle>
        } @else if (field.type === 'textarea') {
          <mat-form-field appearance="outline"><mat-label>{{field.displayName}}</mat-label><textarea matInput rows="3" [ngModel]="meta[field.key] ?? ''" (ngModelChange)="updateMetaValue(field, $event)" [required]="!!field.mandatory"></textarea>@if (field.description) {<mat-hint>{{field.description}}</mat-hint>}</mat-form-field>
        } @else {
          <mat-form-field appearance="outline"><mat-label>{{field.displayName}}</mat-label><input matInput [type]="field.type === 'number' ? 'number' : field.type === 'date' ? 'date' : 'text'" [ngModel]="meta[field.key] ?? ''" (ngModelChange)="updateMetaValue(field, $event)" [required]="!!field.mandatory">@if (field.description) {<mat-hint>{{field.description}}</mat-hint>}</mat-form-field>
        }
        @if (showValidationErrors && isRequiredValueMissing(field)) {
          <small class="meta-field-error" role="alert">{{'contentTypes.metaValueRequired' | translate}}</small>
        }
      }
    </div>
  }
</section>
